import React, { ReactNode } from 'react'

import './Detail.css'
import { DetailProvider } from './DetailContext'

const Detail = ({ children, color = "white" }: { children: ReactNode, color?: string }) => {
    return (
        <DetailProvider theme={{ color }}>
            <div className='drawer-detail'>
                {children}
            </div>
        </DetailProvider>
    )
}

export default Detail
